export default __webpack_public_path__ + "static/1invoice-720d57b1f644c1a678314cc6d4de7f94.png";